import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _InterestMora } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { BankAccountSelect } from "../../../../erp/cellEditor/BankAccount/BankAccountSelect";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { InputMoney } from "../../../../theme/Input/InputMoney";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";



export const InterestMora = () => {

    const InterestMora = useDataBean(_InterestMora);

    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: '', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    
    useEffect(()=>{
       getLista(); 
    },[])

    useEffect(()=>{
        InterestMora.setBean({...InterestMora.bean,"YearInteres":Year});
    },[Year])


    const getLista = () => {
        if (!Year) {
            toast.warning("Debe seleccionar un Año.");
            return;
        }
        InterestMora.instance.getInterestMoraRender(Year).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }

            }
        )

    }




    const create = () => {
        InterestMora.setBean({
            
            State: 1,
            IDEmployee: _single.getAccountID(),
            YearInteres:Year

        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        //console.log(Project.bean);

        InterestMora.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        InterestMora.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }




    const head = [
        { title: 'ID', property: 'IDInterestMora', visible: false },
        { title: 'Año', property: 'YearInteres', visible: true, mask: MASK_NUMBER },
        // { title: 'Mes', property: 'MonthInteres', visible: true },
        { title: 'Periodo', property: 'Periodo', visible: true },
        { title: 'Tasa', property: 'RatePercent', visible: true, mask: MASK_NUMBER },
        { title: 'Usuario Logueado', property: 'EmployeeName', visible: true },


    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },


        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Interes de Mora">
            <div className="row">
                <div className="col-md-6">
                    <YearSelector value={Year} tittle="Año" onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={InterestMora.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <>
                            <div className="row">
                                <div className="col-md-6">
                                    <YearSelector value={InterestMora.bean.YearInteres} tittle="Año" onChange={(e) => { InterestMora.setBean({ ...InterestMora.bean, "YearInteres": e }) }} />
                                </div>
                                <div className="col-md-6">
                                    <MonthConstantsEditor idSelect={InterestMora.bean.MonthInteres} onChange={(e) => { InterestMora.setBean({ ...InterestMora.bean, "MonthInteres": e }) }} label="Mes" name="" />
                                </div>
                                <div className="col-md-12">
                                    <InputMoney _label="Tasa" _value={InterestMora.bean.RatePercent} onChange={(e) => { InterestMora.setBean({ ...InterestMora.bean, "RatePercent": e }) }} />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}